import { TiptapDoc, TiptapNode } from './tiptap-types';

export const extractMentionIds = (doc: TiptapDoc): string[] => {
  const ids = new Set<string>();
  const walk = (nodes: TiptapNode[] = []) => {
    for (const node of nodes) {
      if (node.type === 'mention' && typeof node.attrs?.id === 'string') {
        ids.add(node.attrs.id);
      }
      if (node.content) {
        walk(node.content);
      }
    }
  };
  walk(doc.content);
  return [...ids];
};

export const resolveMentionsInDoc = (doc: TiptapDoc, userMap: Map<string, string>): TiptapDoc => {
  const walkNodes = (nodes: TiptapNode[]): TiptapNode[] =>
    nodes.map(node => {
      if (node.type === 'mention' && typeof node.attrs?.id === 'string') {
        const name = userMap.get(node.attrs.id);
        return name ? { ...node, attrs: { ...node.attrs, label: name } } : node;
      }
      if (node.content) {
        return { ...node, content: walkNodes(node.content) };
      }
      return node;
    });

  return { ...doc, content: walkNodes(doc.content) };
};

export const isDocEmpty = (doc: TiptapDoc | null): boolean => {
  if (!doc) {
    return true;
  }
  const hasText = (nodes: TiptapNode[]): boolean =>
    nodes.some(node => {
      if (node.type === 'text' && node.text?.trim()) {
        return true;
      }
      if (node.type === 'mention') {
        return true;
      }
      return node.content ? hasText(node.content) : false;
    });
  return !hasText(doc.content);
};
